import { render, staticRenderFns } from "./ClinicAssessments.vue?vue&type=template&id=26414315"
import script from "./ClinicAssessments.vue?vue&type=script&lang=js"
export * from "./ClinicAssessments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports